import React, { Fragment, useEffect } from "react";
import { Menu, Transition } from "@headlessui/react";
import { TbCategory } from "react-icons/tb";
import { HiOutlineChevronDown } from "react-icons/hi";
import { useSelector, useDispatch } from "react-redux";
import { categoryList } from "../redux/slices/categorySlice";
import { Link, useParams } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DesktopMenu = () => {
  const categories = useSelector((state) => state.category.data);
  const dispatch = useDispatch();

  const { name = "all", category = "all" } = useParams();

  const getFilterUrl = (filter) => {
    const filterCategory = filter.category || category;
    const filterName = filter.name || name;
    return `/search/category/${filterCategory}/name/${filterName}`;
  };

  useEffect(() => {
    dispatch(categoryList());
  }, [dispatch]);

  return (
    <div className="hidden sm:flex justify-center items-center w-full">
      <div className="hidden sm:flex h-[8vh] w-[90vw] px-4 items-center justify-start">
        <Menu as="div" className="relative inline-block text-left">
          <div>
            <Menu.Button className="flex items-center justify-center gap-x-1.5 rounded-md bg-yellow-400 hover:bg-yellow-500 text-[#242424] px-4 py-2.5 text-[16px] font-medium transition-colors duration-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300">
              <TbCategory className="mr-2 h-5 w-5 text-[#242424]" />
              Kateqoriyalar
              <HiOutlineChevronDown className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:rotate-180" aria-hidden="true" />
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-150"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute left-0 z-10 mt-2 min-w-[240px] max-w-[320px] origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1 max-h-[60vh] overflow-y-auto">
                {categories?.map((category, index) => (
                  <Menu.Item key={index}>
                    {({ active }) => (
                      <Link
                        to={getFilterUrl({ category: category?.title })}
                        className={classNames(
                          active
                            ? "bg-gray-100 text-gray-900"
                            : "text-gray-700",
                          "flex items-center justify-between px-4 py-3 text-sm border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors duration-200"
                        )}
                      >
                        <span>{category?.title}</span>
                        <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-1 rounded-full ml-2 transition-all duration-300 hover:bg-yellow-200">
                          {category?.productCount}
                        </span>
                      </Link>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>

        <div className="ml-8 flex space-x-8">
          <a
            href="/allproducts"
            className="text-[#242424] hover:text-yellow-600 px-3 py-2 text-[16px] font-medium relative group transition-colors duration-300"
          >
            Məhsullar
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-400 group-hover:w-full transition-all duration-300"></span>
          </a>

          <a
            href="/#about"
            className="text-[#242424] hover:text-yellow-600 px-3 py-2 text-[16px] font-medium relative group transition-colors duration-300"
          >
            Haqqımızda
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-400 group-hover:w-full transition-all duration-300"></span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default DesktopMenu;